import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

class Cart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            count: 0,
            bulkVariationCartCount: 0,
        };
    }

    render() {
        console.log("cart->", this.props.count);
        console.log("cart->", this.props.bulkVariationCartCount);
        let counter = 0
        if(this.props.count){
            counter = this.props.count
        }else if( this.props.bulkVariationCartCount){
             counter = this.props.bulkVariationCartCount
        }
        return (
            <div>
                <span className="badge badge-warning" id="lblCartCount">
                    {counter}
                </span>
                <i className="fa fa-shopping-cart fa-4x " aria-hidden="true"></i>
            </div>
        );
    }
}
Cart.propTypes = {
    count: PropTypes.number,
    bulkVariationCartCount: PropTypes.number,
};
Cart.defaultProps = {
    count: 0,
};

const mapStateToProps = (state) => ({
    count: state.addToCartScenarioCollectionData.count,
    bulkVariationCartCount: state.bulkVariationCartCountReducerStatus.totalBulkVariationSelected,
});

export default connect(mapStateToProps, undefined)(Cart);
